<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import CitasHoyQueue from '../widgets/CitasHoyQueue.svelte';
  import ActiveIngresosQueue from '../widgets/ActiveIngresosQueue.svelte';
  import OpenCuentasWidget from '../widgets/OpenCuentasWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import KpiCard from '../widgets/KpiCard.svelte';
  import { Citas, Cuentas, Cobros, Ingresos } from '../../../lib/api';
  import { tenantCtx } from '../../../lib/tenant.svelte';
  import { clinicPreview, effectiveOrgTipo } from '../../../lib/clinic-preview.svelte';
  import { isClinicOrgTipo } from '../../../lib/navigation';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let citasHoy = $state(0);
  let cuentasAbiertas = $state(0);
  let ingresos = $state(0);
  let cobrosPendientes = $state(0);

  const esClinica = $derived(
    tenantCtx.isClinicEdition
      || isClinicOrgTipo(effectiveOrgTipo(tenantCtx.orgTipo as import('../../../lib/navigation').OrgTipo | null, tenantCtx.isHospitalEdition))
      || !!clinicPreview.org,
  );

  async function cargar() {
    const dia = new Date().toISOString().slice(0, 10);
    const [citas, cuentas, ing, pendientes] = await Promise.all([
      Citas.listar(dia),
      Cuentas.list(),
      Ingresos.activos().catch(() => []),
      esClinica ? Cobros.pendientes().catch(() => []) : Promise.resolve([]),
    ]);
    citasHoy = citas.filter(c => c.estado !== 'CANCELADA' && c.estado !== 'ATENDIDA').length;
    cuentasAbiertas = cuentas.filter(c => c.estado === 'ABIERTA' || !c.estado).length;
    ingresos = ing.length;
    cobrosPendientes = pendientes.length;
  }

  const actions = [
    { id: 'agenda', label: 'Agenda', icon: '' },
    { id: 'pacientes', label: 'Nuevo paciente', icon: '' },
    { id: 'episodios', label: 'Episodios', icon: '' },
    { id: 'cuentas', label: 'Cobrar', icon: '' },
    { id: 'semaforo', label: 'Camas', icon: '' },
  ];

  $effect(() => {
    void esClinica;
    cargar();
    const t = setInterval(cargar, 45000);
    return () => clearInterval(t);
  });
</script>

<DashboardLayout title="Front desk" subtitle="Admisión, citas y cobros del día" variant="recepcion">
  <DashHero emoji='' title="Front desk" subtitle="Admisión, citas y cobros del día" variant="recepcion" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <KpiCard label="Citas pendientes" value={citasHoy} tone="brand" />
    {#if esClinica}
      <KpiCard label="Pendientes de cobro" value={cobrosPendientes} tone="warning" />
    {:else}
      <KpiCard label="Cuentas abiertas" value={cuentasAbiertas} tone="warning" />
      <KpiCard label="Ingresos hosp." value={ingresos} tone="success" />
    {/if}
    <KpiCard label="Hoy" value={new Date().toLocaleDateString('es-GT', { day: '2-digit', month: 'short' })} tone="neutral" />
  </div>

  <div class="dash-grid">
    <div class="col-8"><CitasHoyQueue limit={12} interactive /></div>
    <div class="col-4"><ActiveIngresosQueue limit={8} /></div>
    <div class="col-6"><OpenCuentasWidget limit={10} /></div>
  </div>
</DashboardLayout>
